(function () {
  function initGallery(root) {
    var thumbs = root.querySelectorAll('[data-target-media]');
    var panels = root.querySelectorAll('[data-media-id]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.getAttribute('data-target-media');
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
        panels.forEach(function (panel) { panel.classList.toggle('is-active', panel.getAttribute('data-media-id') === id); });
      });
    });
  }

  function initTabs(root) {
    var buttons = root.querySelectorAll('[data-tab-target]');
    var panels = root.querySelectorAll('.dp-tab-panel');
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        var id = button.getAttribute('data-tab-target');
        buttons.forEach(function (b) { b.classList.toggle('is-active', b === button); b.setAttribute('aria-selected', b === button ? 'true' : 'false'); });
        panels.forEach(function (panel) { panel.classList.toggle('is-active', panel.id === id); });
      });
    });
  }

  function initSticky() {
    var sticky = document.querySelector('[data-dp-sticky-cta]');
    var summary = document.querySelector('.dp-product-summary');
    if (!sticky || !summary || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { sticky.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0.1 });
    observer.observe(summary);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-dp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-dp-tabs]').forEach(initTabs);
    initSticky();
  });
})();

(() => {
  const initDpTabs = (container = document) => {
    const tabGroups = container.querySelectorAll('[data-dp-tabs]');

    tabGroups.forEach((group) => {
      if (group.dataset.dpTabsInitialized === 'true') return;
      group.dataset.dpTabsInitialized = 'true';

      const buttons = Array.from(group.querySelectorAll('[data-dp-tab-target]'));
      const panels = Array.from(group.querySelectorAll('.dp-tab-panel'));

      const activateTab = (button) => {
        const targetId = button.dataset.dpTabTarget;
        const targetPanel = group.querySelector(`#${CSS.escape(targetId)}`);

        if (!targetPanel) return;

        buttons.forEach((btn) => {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
          btn.setAttribute('tabindex', '-1');
        });

        panels.forEach((panel) => {
          panel.classList.remove('is-active');
          panel.setAttribute('hidden', 'hidden');
        });

        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        button.setAttribute('tabindex', '0');

        targetPanel.classList.add('is-active');
        targetPanel.removeAttribute('hidden');
      };

      buttons.forEach((button, index) => {
        button.setAttribute('tabindex', button.classList.contains('is-active') ? '0' : '-1');

        button.addEventListener('click', () => {
          activateTab(button);
        });

        button.addEventListener('keydown', (event) => {
          const currentIndex = buttons.indexOf(button);
          let nextIndex = currentIndex;

          if (event.key === 'ArrowRight') {
            nextIndex = currentIndex + 1 >= buttons.length ? 0 : currentIndex + 1;
          } else if (event.key === 'ArrowLeft') {
            nextIndex = currentIndex - 1 < 0 ? buttons.length - 1 : currentIndex - 1;
          } else if (event.key === 'Home') {
            nextIndex = 0;
          } else if (event.key === 'End') {
            nextIndex = buttons.length - 1;
          } else {
            return;
          }

          event.preventDefault();
          buttons[nextIndex].focus();
          activateTab(buttons[nextIndex]);
        });

        if (index === 0 && !buttons.some((btn) => btn.classList.contains('is-active'))) {
          activateTab(button);
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initDpTabs(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initDpTabs(event.target);
  });
})();
